import { useToastContext } from '#pplx/frontend/aether/toasts/context/useToastContext.js';
import { useTranscription } from '#pplx/frontend/apps/ask/multimodal/speech-recognition/providers/soniox/useTranscription.js';
import { useWebVoiceContext } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/WebVoiceContext.js';
import { WINDOWS_APP_DICTATION_CONFIG } from '#pplx/frontend/components/utils/consts.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
/** Applies Ask Input's microphone configuration and localized error notifications. */
export function useAskInputTranscription({ onStart, onStop, reason, }) {
    const { $t } = useIntl();
    const { openToast } = useToastContext();
    const isVoiceActive = useWebVoiceContext()?.isActive ?? false;
    const callbacks = useMemo(() => ({
        onStart,
        onStop,
        onSilence: () => {
            openToast({
                message: $t({
                    defaultMessage: 'No audio detected. Make sure your microphone is connected and unmuted',
                    description: 'Toast error message shown when no audio is detected during voice transcription',
                    id: '7f40b3b656',
                }),
                variant: 'error',
                timeoutSeconds: 4,
            });
        },
    }), [onStart, onStop, $t, openToast]);
    const transcription = useTranscription({
        callbacks,
        config: WINDOWS_APP_DICTATION_CONFIG,
        reason,
    });
    const { error, startTranscription } = transcription;
    const guardedStartTranscription = useCallback(async () => {
        if (isVoiceActive) {
            logger.info('[transcription] start ignored: web voice is active', { reason });
            return;
        }
        await startTranscription();
    }, [isVoiceActive, reason, startTranscription]);
    useEffect(() => {
        if (error) {
            openToast({
                message: $t({
                    defaultMessage: 'Audio Error: {error}',
                    description: 'Toast error message shown when an audio transcription error occurs',
                    id: '843d93ff5e',
                }, { error }),
                variant: 'error',
                timeoutSeconds: 4,
            });
        }
    }, [error, $t, openToast]);
    return { ...transcription, startTranscription: guardedStartTranscription };
}
//# sourceMappingURL=useAskInputTranscription.js.map